import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { Row, Col } from "react-bootstrap";
import { CurrencyFormat } from "../../../Helpers/Formatters";
import './UnderwritingInfoCard.scss';
import IconHolder from "../../../Helpers/IconHolder";
import { UnderwritingList, StepList, PlanFeatures } from '../../AmericoLoanProtection/Helpers/Constant';
import FeatureCard from '../../../Quoters/Common/Cards/FeatureCard';
import { GetMCTQuotes } from "../../CustomizeTerm/Common/GetMCTQuotes";
import { getBasicInfo } from "../../../../sessionStorage";
import LoanProtectionQuoteCard from "../../Common/Cards/LoanProtectionQuoteCard";
import { getTermHealthHealthClass } from "../Helpers/GetHealthClass";

const useStyles = makeStyles(theme => ({
    detailButton: {
        padding: 0,
        fontSize: 14,
        fontWeight: 700,
        color: theme.palette.primary.main,
        textTransform: "uppercase",
        lineHeight: "24px",
    },
    ratingText: {
        color: theme.palette.primary.main,
    },
}));

export default function UnderwritingInfoCard(props) {
    const classes = useStyles();
    const [currentFeatureStep, setCurrentFeatureStep] = useState(1);
    const [isProductDetailsDialogOpen, setIsProductDetailsDialogOpen] = useState(false);
    const [quoteResults, setQuoteResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const planFeatureLength = PlanFeatures.length;
    const showCardInfo = props.status && props.statuses && (props.status === props.statuses.APPROVED || props.status === props.statuses.APPROVEDMODIFIED || props.status === props.statuses.TOOLONG || props.status === props.statuses.LONGWAIT);  
    const modalQuoteInfo = (quoteResults && quoteResults.length > 0 && quoteResults.filter(x => x.productID === 1017)[0]) || null;

    const setFeatureStep = () => {
        if ((currentFeatureStep + 1) > (planFeatureLength)) {
            setCurrentFeatureStep(1);
        } else {
            setCurrentFeatureStep(currentFeatureStep + 1);
        }
    };
  
    useEffect(() => {
        if (modalQuoteInfo === null) {
            setLoading(true);
            GetMCTQuotes(getBasicInfo(), getTermHealthHealthClass(props.quoter.healthClass), props.quoter.coverageAmount, props.quoter.term, setLoading, () => true, null, setQuoteResults, ['Level', 'Decreasing']);
        }
    }, []);

    const showProductDetails = () => {
        if (quoteResults.length > 0 && modalQuoteInfo) {
        setIsProductDetailsDialogOpen(true);
        }
    };

    useEffect(() => {
        const timeout = setTimeout(setFeatureStep, 4500);

        return () => clearTimeout(timeout);
    }, [currentFeatureStep]);

    return (
        <Row className="d-flex">
            <Col className="coverage-detail-info pt-5">
                <div className="coverage-detail-container">
                    <Row className="coverage-detail">
                        <Col className="carrier-container d-flex justify-content-center align-items-center pr-0">
                            {modalQuoteInfo && modalQuoteInfo.logoUrl ? <img src={modalQuoteInfo.logoUrl} alt="Carrier Logo" /> : <CircularProgress size={25} />}
                            <p className={classes.ratingText}>{modalQuoteInfo && modalQuoteInfo.rating} Rating</p>
                        </Col>
                        <Col className="coverage-container d-flex justify-content-center align-items-start pl-0">
                            <div className="coverage">
                                <h2>Coverage Amount</h2>
                                <p className="coverage-amount"><CurrencyFormat number={props.quoter.coverageAmount} whole /></p>
                                <p className="quote-amount"> <span>{props.quoter.term} Year Decreasing Term</span></p>
                                {loading ? <CircularProgress size={25} />
                                    : <button type="button" className={classes.detailButton} onClick={() => showProductDetails()}>PRODUCT DETAILS</button>}
                            </div>
                        </Col>
                    </Row>
                </div>
                {(showCardInfo) ?
                    <div>
                        <div className="request-step-container">
                            <h2 className="section-title d-flex justify-content-center">What to expect</h2>
                            {renderStepList(StepList)}
                        </div>
                        <div className="plan-feature-container">
                            <h2 className="section-title text-center">Your plan’s best features</h2>
                            <div className="text-slideshow">
                                <ul className={`step${currentFeatureStep}`}>
                                    {PlanFeatures.map((f, index) => <FeatureCard planFeature={f} key={index} />)}
                                </ul>
                            </div>
                        </div>
                    </div> :
                    <div className="request-step-container">
                        <h2 className="section-title text-left"><b>What to expect</b></h2>
                        {renderUnderwritingList(UnderwritingList)}
                    </div>
                }
                {modalQuoteInfo &&
                    <LoanProtectionQuoteCard
                        modalQuoteInfo={modalQuoteInfo}
                        show={isProductDetailsDialogOpen}
                        onHide={() => setIsProductDetailsDialogOpen(false)} />
                }
            </Col>
        </Row>
    );
}

const renderUnderwritingList = (UnderwritingList) => {
    return UnderwritingList.map((array, key) => (
        <div key={key} className="main-div">
            <div className="content mt-2 mb-2" dangerouslySetInnerHTML={{ __html: array.title }} />
            {array.sublist && array.sublist.map((item, subKey) => (
                <div key={subKey} className="mb-2">
                    <div className="d-flex">
                        <div className="d-flex justify-content-center align-item-center">
                            <IconHolder icon={item.icon} viewBox="0 0 25 25" />
                        </div>
                        <div className="main-subtitle mt-1 ml-2" dangerouslySetInnerHTML={{ __html: item.subtitle }} />
                    </div>
                </div>
            ))}
        </div>
    ));
};

const renderStepList = (StepList) => {
    return StepList.map((item, key) => (
        <div key={key} className="main-div step-list">
            <div className="d-flex">
                <div className="d-flex justify-content-center align-item-center">
                    <IconHolder icon={item.icon} viewBox="0 0 25 25" />
                </div>
                <b><div className="main-subtitle mt-1 ml-2" dangerouslySetInnerHTML={{ __html: item.title }} /></b>
            </div>
            {item.sublist && item.sublist.map((item, subKey) => (
                <div key={subKey} className="mb-2">
                    <div className="content subtitle mt-2 mb-2" dangerouslySetInnerHTML={{ __html: item.subtitle }} />
                </div>
            ))}
        </div>
    ));
};

UnderwritingInfoCard.propTypes = {
    quoter: PropTypes.object,
    status: PropTypes.string,
    statuses: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/steps/UnderwritingInfoCard.js